import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_filing-portal-beta/artifacts/x1o2k873_Group%2046%20%282%29.png"
              alt="NextGen Filling Association"
              className="h-12 mb-4"
            />
            <p className="text-sm text-slate-400">
              Your trusted partner for all CA services, company registration, and compliance solutions.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-slate-400 hover:text-amber-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-slate-400 hover:text-amber-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-slate-400 hover:text-amber-400 transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-sm text-slate-400 hover:text-amber-400 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-conditions" className="text-sm text-slate-400 hover:text-amber-400 transition-colors">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services/private-limited" className="text-sm text-slate-400 hover:text-amber-400 transition-colors">
                  Company Registration
                </Link>
              </li>
              <li>
                <Link to="/services/gst" className="text-sm text-slate-400 hover:text-amber-400 transition-colors">
                  GST Registration
                </Link>
              </li>
              <li>
                <Link to="/services/trademark" className="text-sm text-slate-400 hover:text-amber-400 transition-colors">
                  Trademark Registration
                </Link>
              </li>
              <li>
                <Link to="/services/pvt-ltd-compliance" className="text-sm text-slate-400 hover:text-amber-400 transition-colors">
                  Compliance Services
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-center text-sm text-slate-400">
                <Phone size={16} className="mr-2" />
                <a href="tel:+919509363261" className="hover:text-amber-400 transition-colors">
                  +91 9509363261
                </a>
              </li>
              <li className="flex items-center text-sm text-slate-400">
                <Phone size={16} className="mr-2" />
                <a href="tel:+919541709908" className="hover:text-amber-400 transition-colors">
                  +91 9541709908
                </a>
              </li>
              <li className="flex items-center text-sm text-slate-400">
                <Mail size={16} className="mr-2" />
                <a href="mailto:info@nextgenfilling.com" className="hover:text-amber-400 transition-colors">
                  info@nextgenfilling.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8">
          <p className="text-sm text-slate-400 mb-4">
            <strong>Disclaimer:</strong> Our services are designed to provide professional assistance with documentation, filing, and compliance support for businesses.
          </p>
          <p className="text-sm text-slate-500 text-center">
            © {new Date().getFullYear()} NextGen Filling Association. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;